export default function Footer(){
    return(
        <footer className="footer">
                <a href="https://github.com/amelia2802" target="_blank"  rel="noreferrer"><i class="fab fa-github-alt fa-2x"></i></a> 
                <a href="https://www.linkedin.com/in/amelia-dutta-40bb8a17b" target="_blank"  rel="noreferrer"><i class="fab fa-linkedin fa-2x"> </i></a>
                <a href="https://www.twitter.com/AmeliaDutta" target="_blank"  rel="noreferrer"><i class="fab fa-twitter fa-2x"> </i></a>
        </footer>
    )
}